import {connect} from 'react-redux';
import {MainScene as Component} from './MainScene';
import {FILES} from '../../Data';
import {setSimulationLevel} from '@learningblocks/protocol-redux/lib/Actions';

function mapStateToProps(state) {
  return {
    showLevelModal: state.notebook.showLevelModal,
    levelSelected: !state.notebook.showLevelModal,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    setLevel: (levelId) => {
      dispatch(setSimulationLevel({
          levelData: FILES[levelId.value],
          levelId: levelId
      }));
    },
  };
}

export const MainScene = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
